import { fullLogoutAndDispatch } from '#/reduxState/currentUser/currentUserUtils';
import { getStateOutsideOfComponent, staticDispatch } from '#/reduxState/store';

import { setRestrictedRegion } from './actions';

import type { RegionState } from './types';

export async function handleRestrictedRegion(
  restrictedRegion: RegionState['restrictedRegion']
) {
  const {
    wallet,
    delegatedKey: { authorization },
  } = await getStateOutsideOfComponent();

  staticDispatch(setRestrictedRegion(restrictedRegion));

  // TODO: circular dependency: handle this in component layer !!!
  if (restrictedRegion) {
    await fullLogoutAndDispatch(wallet, authorization);
  }
}
